var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 672,
    height: 451,
    viewBox: "0 0 672 451",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask Group",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 146,
    y: -201,
    width: 568,
    height: 569
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 6"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 429.935,
    cy: 83.3625,
    r: 283.693,
    fill: "url(#pattern0)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 429.935,
    cy: 83.3625,
    r: 283.693,
    fill: "url(#paint0_linear)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Captura de Tela 2021-05-27 a\xCC\x80s 8.32 1",
    opacity: 0.7,
    x: -25.4795,
    y: -165,
    width: 1224.12,
    height: 641.275,
    fill: "url(#pattern1)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 8",
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 430.398,
    cy: 82.6164,
    r: 325.307,
    stroke: "url(#paint1_linear)"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 10",
    opacity: 0.4,
    cx: 429.473,
    cy: 83.5419,
    r: 211.885,
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "direction"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 419.52,
    y: 398.984,
    width: 21.4848,
    height: 21.4848,
    rx: 10.7424,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "S",
    d: "M430.178 412.822C429.768 412.822 429.408 412.75 429.098 412.606C428.789 412.462 428.546 412.257 428.37 411.99C428.2 411.723 428.112 411.406 428.106 411.038H429.002C429.008 411.337 429.112 411.59 429.314 411.798C429.517 412.006 429.802 412.11 430.17 412.11C430.496 412.11 430.749 412.033 430.93 411.878C431.117 411.718 431.21 411.515 431.21 411.27C431.21 411.073 431.165 410.913 431.074 410.79C430.989 410.667 430.869 410.566 430.714 410.486C430.565 410.406 430.392 410.334 430.194 410.27C429.997 410.206 429.789 410.137 429.57 410.062C429.138 409.918 428.813 409.731 428.594 409.502C428.381 409.273 428.274 408.971 428.274 408.598C428.269 408.283 428.341 408.009 428.49 407.774C428.645 407.539 428.858 407.358 429.13 407.23C429.408 407.097 429.73 407.03 430.098 407.03C430.461 407.03 430.778 407.097 431.05 407.23C431.328 407.363 431.544 407.55 431.698 407.79C431.853 408.025 431.933 408.299 431.938 408.614H431.042C431.042 408.47 431.005 408.334 430.93 408.206C430.856 408.073 430.746 407.963 430.602 407.878C430.458 407.793 430.282 407.75 430.074 407.75C429.808 407.745 429.586 407.811 429.41 407.95C429.24 408.089 429.154 408.281 429.154 408.526C429.154 408.745 429.218 408.913 429.346 409.03C429.474 409.147 429.65 409.246 429.874 409.326C430.098 409.401 430.354 409.489 430.642 409.59C430.92 409.681 431.168 409.79 431.386 409.918C431.605 410.046 431.778 410.214 431.906 410.422C432.04 410.63 432.106 410.894 432.106 411.214C432.106 411.497 432.034 411.761 431.89 412.006C431.746 412.246 431.53 412.443 431.242 412.598C430.954 412.747 430.6 412.822 430.178 412.822Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "direction_2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 92.7241,
    y: 72.188,
    width: 21.4848,
    height: 21.4848,
    rx: 10.7424,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "W",
    d: "M101.179 85.9382L99.6666 80.3302H100.579L101.691 84.9702L102.971 80.3302H103.907L105.147 84.9702L106.259 80.3302H107.171L105.635 85.9302H104.643L103.419 81.5382L102.155 85.9302L101.179 85.9382Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0",
    transform: "translate(-0.454853) scale(0.00112867)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1",
    transform: "translate(0 -0.0828848) scale(0.000361795 0.000690622)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 100.591,
    y: -243.19,
    width: 659.614,
    height: 659.614,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 429.935,
    y1: -200.33,
    x2: 429.935,
    y2: 367.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141414",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 662.072,
    y1: -159.057,
    x2: 139.651,
    y2: 258.202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.18
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapa);
export default __webpack_public_path__ + "static/media/mapa.beea70f39157814688feddb1d4f9d359.svg";
export { ForwardRef as ReactComponent };